import React from 'react'

const DeleteIcon = ({className, onClick}) => (
    <svg viewBox="0 0 184 184" className={className} onClick={onClick}>
        <g transform="translate(5.000000, 5.000000)" stroke="#fff" strokeWidth="10">
            <circle cx="87" cy="87" r="87" fill="none"/>
            <line x1="61.6477093" y1="61.2334957" x2="113.266504" y2="113.559398" id="Line" strokeLinecap="round"/>
            <line x1="113.266504" y1="62.2941559" x2="60.9406025" y2="113.912951" id="Line" strokeLinecap="round"/>
        </g>
    </svg>
)

export default DeleteIcon